// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-n_gX","galleryItem_borderTopRadius":"c-n_gY","galleryItem__image":"c-n_gZ","galleryItem__image_withBlur":"c-n_ha"};